import React, { useMemo } from "react";
import styled from "styled-components";
import { Ring } from "@uiball/loaders";
import MainCard from "@appsinti/ui-core/MainCard";
import NoDataAvailable from "@appsinti/ui-core/NoDataAvailable";
import { PreviewDataProvider, usePreviewData } from "./data";
import CardsQuarter from "./components/CardsQuarter";
import CardsHalf from "./components/CardsHalf";

const CustomMainCard = styled(MainCard)`
  .body {
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    align-items: stretch;
  }
`;

export type Size = "half" | "quarter";

const Body: React.FC<{ size: Size }> = ({ size }) => {
  const { preview, loading } = usePreviewData();

  const lastUpdatedTime = useMemo(() => {
    if (preview?.lastUpdate) {
      return new Date(preview.lastUpdate);
    }
  }, [preview]);

  const renderBody = () => {
    if (loading && !preview) {
      return (
        <div style={{ alignSelf: "center" }}>
          <Ring color={"white"} size={30} />
        </div>
      );
    }

    if (!preview) return <NoDataAvailable />;

    return (
      <>
        {size === "quarter" && <CardsQuarter preview={preview} />}
        {size === "half" && <CardsHalf preview={preview} />}
      </>
    );
  };

  return (
    <CustomMainCard title={"Sales"} lastUpdatedTime={lastUpdatedTime}>
      {renderBody()}
    </CustomMainCard>
  );
};

const Preview: React.FC<{ appId: number; size: Size }> = ({ appId, size }) => {
  return (
    <PreviewDataProvider appId={appId}>
      <Body size={size} />
    </PreviewDataProvider>
  );
};

export default Preview;
